var map = {
	"./clever-insights-logo-component.svg": "8278",
	"./clever-insights-weclever-logo-component.svg": "8fc8",
	"./icons/icon-arrow-down-component.svg": "a17d",
	"./icons/icon-arrow-right-component.svg": "9c12",
	"./icons/icon-balloon-cross-component.svg": "92c6",
	"./icons/icon-bar-chart-component.svg": "7ed8",
	"./icons/icon-celebration-component.svg": "51a4",
	"./icons/icon-chart-growing-round-bars-bubble-component.svg": "b553",
	"./icons/icon-chat-bright-star-component.svg": "fe14",
	"./icons/icon-chat-component.svg": "9454",
	"./icons/icon-close-component.svg": "d0e1",
	"./icons/icon-cloud-upload-component.svg": "b4de",
	"./icons/icon-csat-heart-bubble-component.svg": "5650",
	"./icons/icon-csat-star-component.svg": "6222",
	"./icons/icon-custom-component.svg": "965e",
	"./icons/icon-dashboard-component.svg": "28da",
	"./icons/icon-demographic-profile-component.svg": "73f8",
	"./icons/icon-dislike-component.svg": "03e2",
	"./icons/icon-dollar-sign-bubble-component.svg": "ca79",
	"./icons/icon-expand-component.svg": "3e10",
	"./icons/icon-face-happy-component.svg": "aad6",
	"./icons/icon-face-neutral-component.svg": "4540",
	"./icons/icon-face-sad-component.svg": "7cfe",
	"./icons/icon-feeling-negative-component.svg": "e973",
	"./icons/icon-feeling-neutral-component.svg": "eb04",
	"./icons/icon-feeling-positive-component.svg": "adeb",
	"./icons/icon-filter-component.svg": "b75a",
	"./icons/icon-flag-component.svg": "5c96",
	"./icons/icon-flag-outline-component.svg": "666d",
	"./icons/icon-forum-component.svg": "3db4",
	"./icons/icon-groups-component.svg": "4d31",
	"./icons/icon-info-component.svg": "4114",
	"./icons/icon-insights-component.svg": "5862",
	"./icons/icon-leads-component.svg": "19bb",
	"./icons/icon-like-component.svg": "7199",
	"./icons/icon-list-exclamation-component.svg": "b6fa",
	"./icons/icon-list-x-component.svg": "0458",
	"./icons/icon-nav-business-insights-component.svg": "2cf5",
	"./icons/icon-nav-conversation-data-component.svg": "594c",
	"./icons/icon-nav-funnel-component.svg": "56bf",
	"./icons/icon-nav-leads-journey-component.svg": "dbe7",
	"./icons/icon-nav-leads-list-component.svg": "b57e",
	"./icons/icon-nav-leads-upload-component.svg": "c811",
	"./icons/icon-nav-overview-component.svg": "bc22",
	"./icons/icon-non-filter-component.svg": "6caf",
	"./icons/icon-person-search-component.svg": "2ac8",
	"./icons/icon-rating-star-component.svg": "ed9a",
	"./icons/icon-rating-star-outline-component.svg": "042c",
	"./icons/icon-result-component.svg": "568c",
	"./icons/icon-reviews-component.svg": "daf7",
	"./icons/icon-robot-component.svg": "f223",
	"./icons/icon-rounded-important-component.svg": "dbe3",
	"./icons/icon-running-with-errors-component.svg": "52ee",
	"./icons/icon-search-component.svg": "893a",
	"./icons/icon-search-data-component.svg": "4171",
	"./icons/icon-sparkles-component.svg": "41fa",
	"./icons/icon-star-component.svg": "1b36",
	"./icons/icon-star-outline-component.svg": "736c",
	"./icons/icon-stars-outline-component.svg": "065b",
	"./icons/icon-timeline-component.svg": "c42a",
	"./icons/icon-trashcan-component.svg": "b4d1",
	"./icons/icon-trending-down-component.svg": "a6e9",
	"./icons/icon-trending-up-component.svg": "4825",
	"./icons/icon-upload-component.svg": "73dc",
	"./icons/icon-world-component.svg": "c003"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "59b2";